import { ReactNode } from 'react';
import { GridItem, Typography } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';

interface PaymentDetailsSidePanelRowProps {
    labelTextKey: Mews.TextKey;
    children?: ReactNode;
    hideIfNull?: boolean;
}
export const PaymentDetailsSidebarRow = ({ labelTextKey, children }: PaymentDetailsSidePanelRowProps) => {
    if (!children) {
        return null;
    }

    return (
        <>
            <GridItem>
                <Typography textStyle="bodyMedium" variant="tertiary" as="div">
                    <LocalizedText textKey={labelTextKey} />
                </Typography>
            </GridItem>
            <GridItem>{children}</GridItem>
        </>
    );
};

export const PaymentDetailsSidebarRowTypography = ({
    labelTextKey,
    value,
}: {
    labelTextKey?: Mews.TextKey;
    value: string | null | undefined;
}) => {
    if (!value || !labelTextKey) {
        return null;
    }

    return (
        <PaymentDetailsSidebarRow labelTextKey={labelTextKey}>
            <Typography textStyle="bodyMediumStrong" as="div">
                {value}
            </Typography>
        </PaymentDetailsSidebarRow>
    );
};
